import { InjectionToken } from '@angular/core';

import { FrontendEnvironment } from '../../../environments/environment.model';

export const FRONTEND_ENVIRONMENT = new InjectionToken<FrontendEnvironment>('FRONTEND_ENVIRONMENT');
